// 文章2数据信息
export default {
  id: '2',
  title: '28天控糖脱药挑战营',
  createTime: '2025-03-21 10:00:00',
  content: `![img](https://cdn.keihong.tech/img/20250422161248739.png)

#### 适合客户

想体验短期内安全降糖、脱药、停针的糖友。

#### 服务时长

28天全程专业指导确保健康转变。

**服务权益：**

1.**细胞母乳**：30天足量供应，持续调节血糖平衡。
2.**血糖监测**：提供2个连续血糖监测仪，全程掌握血糖变化。
3.**营养疗法**：轻断食细胞营养方案，科学饮食重塑代谢。
4.**运动指导**：2次线上咨询（各20分钟）和2套居家训练方案。
5.**专业陪伴**：控糖老师30天悉心指导，终身线上咨询随访。`
}
